import React, { useEffect, useState } from 'react'
import './index.css'
import { Button } from '@mui/material'

export default function AcceptCookie() {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const acceptedCookiePolicy = document.cookie.includes("acceptedCookiePolicy=true");
        setOpen(!acceptedCookiePolicy)
        // setOpen(true)
    }, [])

    const handleAccept = () => {
        document.cookie = "acceptedCookiePolicy=true; max-age=31536000; path=/";
        setOpen(false)
    }

    const handleDeny = () => {
        document.cookie = "acceptedCookiePolicy=false;";
        setOpen(false)
    }

    return (
        <>
            {open ? (<div className="block"></div>) : null}
            <div className={`cp-content${open ? '' : '-hide'}`}>

                <div className="cp-title">This website uses cookies</div>
                <div className="cp-info">
                    We use cookies to make interactions with our websites and services easy and meaningful.
                    For more information about cookies and the way to disable cookies,
                    {" "}<a href="https://www.avast.com/c-enable-disable-cookies#topic-2" target="_blank" rel="noreferrer">click here</a>.
                </div>

                <div className="btn-area">
                    <Button size="large" sx={{ width: '100px', marginRight: '40px' }} onClick={handleDeny}>Deny All</Button>
                    <Button variant="contained" sx={{ width: '100px' }} onClick={handleAccept}>Accept All</Button>
                </div>

            </div>
        </>

    )
}
